import React, { useState, useEffect, Fragment, useRef } from 'react';
import groupService from '../../../Group/services';
import service from '../service';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { PageHeader } from '../../../../Common';
import Joi from '@hapi/joi';
import { validateProperty, validate } from "../../../Common";
import { CSVLink } from "react-csv";
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import "react-datepicker/dist/react-datepicker.css";
import { factoryEmployeeAttendanceReportSchema } from "../factoryEmployeeAttendanceReportSchema";
import { TableContent } from '../../../Common/Table/tableContent';
import $ from 'jquery';
import { LoadingSpinerComponent } from '../../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../Common/services';
import tokenService from '../../../../Common/tokenDecoder';
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';

const screenCode = 'FACTORYEMPLOYEEATTENDANCEREPORT'

export function FactoryEmployeeAttendanceReport(props) {

    const componentRef = useRef();

    const [groups, setGroups] = useState([]);
    const [factories, setFactories] = useState();
    const [routes, setRoutes] = useState();
    const [isTableHide, setIsTableHide] = useState(true);
    const [searchData, setsearchData] = useState({
        groupID: "0",
        factoryID: "0",
        routeID: "0",
        employeeNumber:"",
        toDate: "",
        fromDate: ""
       
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "0",
        factory: "0",
        route: "0",
        toDate: "",
        fromDate: "",
      })

    const pdfRef = React.createRef();
    const [errors, setErrors] = useState({});

    const options = {
        orientation: 'landscape',
        unit: 'in',
        format: [1100, 700],

    };

    const [isReportButtonsEnabled, setIsReportButtonsEnabled] = useState(false);
    
    const schema = Joi.object(factoryEmployeeAttendanceReportSchema).options({ allowUnknown: true });
    const contentRowNames = ["operationEntityName", "collectionPointName", "factoryEmployeeNumber", "firstName","designationName","createdDate","inTime","outTime"]
    const csvHeaders = [
        { label: "Factory", value: "operationEntityName" },
        { label: "Route", value: "collectionPointName" },
        { label: "Employee Number", value: "factoryEmployeeNumber" },
        { label: "Employee Name", value: "firstName" },
        { label: "Designation", value: "designationName" },
        { label: "Date", value: "createdDate" },
        { label: "InTime", value: "inTime" },
        { label: "OutTime", value: "outTime" },
    ];

    const [data, setdata] = useState([]);
    const [csvData, setCsvData] = useState([]);

    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const [searchButtonHide, setSearchButtonHide] = useState(false);
    const [buttonHide, setButtonHide] = useState(true);

    useEffect(() => {
        createDataTable();
        trackPromise(
            getPermissions()
        );
    }, [])

    useEffect(() => {
        trackPromise(
            getOperationEntitiesForDropdown()
        )
    }, [searchData.groupID])

    useEffect(() => {
        trackPromise(
            getAllRoutesForDropDown()
        )
    }, [searchData.factoryID]);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWFACTORYEMPLOYEEATTENDANCEREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');
        setPermissions({
            ...permissionList,

            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setsearchData({
            ...searchData,
            groupID: token.groupID,
            factoryID: token.operationEntityID
        });

        trackPromise(
            getGroupsForDropDown()
        );
    }

    function destroyDataTable() {
        $('#example').DataTable().destroy();
    }

    function createDataTable() {
        $('#example').DataTable({
            paging: false,
            searching: false,
            info: false
        });
    }

    async function getGroupsForDropDown() {
        const groupsList = await groupService.getGroupsForDropdown();
        setGroups(groupsList);
    }

    async function getOperationEntitiesForDropdown() {
        const opEntities = await service.getFactoriesByGroupID(searchData.groupID);
        setFactories(opEntities);
    }

    async function getAllRoutesForDropDown() {
        const routeList = await service.getAllRoutesByFactoryID(searchData.factoryID);
        setRoutes(routeList);
    }

    
   function handleChange(e) {
        e.preventDefault();

        const target = e.target;
        const value = target.value;

        const error = { ...errors };
        const errorMessage = validateProperty(target, factoryEmployeeAttendanceReportSchema);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setsearchData({
            ...searchData,
            [e.target.name]: value
        })
    }

    async function handleSearch(e) {

        const attendance = [];
        
        e.preventDefault();

        setIsTableHide(true);
        setButtonHide(true);

        const errorMessages = validate(schema, searchData);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        getSelectedDropdownValuesForReport(searchData);
        
        const result = await service.getFactoryEmployeeAttendanceReportData(searchData);
        
        if (result.length > 0) {
            result.map((item) => {
                let rowdata = {
                    operationEntityName :item.operationEntityName,
                    collectionPointName :item.collectionPointName,
                    factoryEmployeeNumber : item.factoryEmployeeNumber,
                    firstName : item.firstName,
                    designationName : item.designationName,
                    createdDate : item.createdDate.split('T')[0],
                    inTime : item.inTime.hours+":"+ item.inTime.minutes+":"+item.inTime.seconds, 
                    outTime : item.outTime.hours+":"+ item.outTime.minutes+":"+item.outTime.seconds
                }
                 attendance.push(rowdata);
                           
            });
            setdata(attendance);
           
            setIsTableHide(false);
            setIsReportButtonsEnabled(true);
        } else {
            setIsReportButtonsEnabled(false);
        }

        setButtonHide(false);
        setIsReportButtonsEnabled();

        const comlpeteData = [...attendance];
        setCsvData(comlpeteData)

    }

    function createFile() {
        var settings = {
            sheetName: 'Daily Collection Detailed',
            fileName: 'DailyCollectionDetailedReport',
            writeOptions: {}
        }
        xlsx(csvHeaders, csvData, settings, true)
    }

    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
          ...selectedSearchValues,
          group: groups[searchForm.groupID],
          factory: factories[searchForm.factoryID],
          route:routes[searchForm.routeID],
          toDate: searchForm.toDate,
          fromDate: searchForm.fromDate
        })
      }


      function onCancelClick() {
        clearState();
    }

    function clearState() {

        setsearchData({
            groupID: "0",
            factoryID: "0",
            routeID: "0",
            employeeNumber:"",
            toDate: "",
            fromDate: "",
        });
        setIsTableHide(true);
        setErrors("");
        setIsReportButtonsEnabled(false);
    }

      
    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    function hideSearchButton() {

        setSearchButtonHide(true);
    }

    function showSearchButton() {

        setSearchButtonHide(false);
    }
    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="card">
                    <div ref={pdfRef} className="card-body">
                        <div className="row">
                            <PageHeader
                                title="Factory Employee Attendance Report"
                                isButtonEnable={false}
                            />
                        </div>
                        <form >
                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <InputLabel shrink id="groupID">Group *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="groupID"
                                        disabled={!permissionList.isGroupFilterEnabled}
                                        name="groupID"
                                        value={searchData.groupID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Group--</MenuItem>
                                        {generateDropDownMenu(groups)}
                                    </Select>
                                    {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                </div>

                                <div className="col-md pb-1">
                                    <InputLabel shrink id="factoryID">Factory *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="factoryID"
                                        disabled={!permissionList.isOperationEntityFilterEnabled}
                                        name="factoryID"
                                        value={searchData.factoryID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Factory--</MenuItem>
                                        {generateDropDownMenu(factories)}
                                    </Select>
                                    {errors["factoryID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["factoryID"]}</FormHelperText>}
                                </div>

                                <div className="col-md pb-1">
                                    <InputLabel shrink id="routeID">Route *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="routeID"
                                        name="routeID"
                                        value={searchData.routeID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Route--</MenuItem>
                                        {generateDropDownMenu(routes)}
                                    </Select>
                                    {errors["routeID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["routeID"]}</FormHelperText>}
                                </div>
                            </div>

                            <div className="form-group row">
                                <div className="col-md-4 pb-1">
                                        <TextField fullWidth label="Employee Number"
                                            name="employeeNumber"
                                            id="employeeNumber"
                                            value={searchData.employeeNumber}
                                            type="text"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["employeeNumber"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["employeeNumber"]}</FormHelperText>}
                                    </div>      

                                <div className="col-md pb-1">
                                    <TextField
                                        id="fromDate"
                                        label="From Date"
                                        name="fromDate"
                                        type="date"
                                        fullWidth
                                        onChange={(e) => handleChange(e)}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </div>

                                <div className="col-md pb-1">
                                    <TextField
                                        id="toDate"
                                        label="To Date"
                                        name="toDate"
                                        type="date"
                                        fullWidth
                                        onChange={(e) => handleChange(e)}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </div>

                               
                            </div>

                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <input
                                        disabled={validate(schema, searchData)}
                                        type="button"
                                        className="btn btn-primary"
                                        value="Generate"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />

                                    <input type="reset" className="btn btn-warning pull-right"
                                        value="Cancel"
                                        onClick={onCancelClick}
                                    />
                                </div>
                            </div>
                        </form>

                        {isTableHide ? null :
                            <div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="table-responsive row-top-gap">
                                            <table id="example" className="display dataTable no-footer">
                                                <thead>
                                                    <tr>
                                                        <th>Factory</th>
                                                        <th>Route</th>
                                                        <th>Employee Number</th>
                                                        <th>Employee Name</th>
                                                        <th>Designation</th>
                                                        <th>Date</th>
                                                        <th>InTime</th>
                                                        <th>OutTime</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <TableContent
                                                        data={data}
                                                        contentRowNames={contentRowNames}
                                                        hasEdit={false}
                                                    />
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                                <div className="pt-2">
                                    
                                    <input
                                        type="button"
                                        className="btn btn-primary pull-right ml-2"
                                        value="Excel"
                                        onClick={createFile}
                                    />
                                    <ReactToPrint
                                        documentTitle={"Factory Employee Attendance Report"}
                                        trigger={() => <input
                                         type="submit"
                                         className="btn btn-primary pull-right ml-2"
                                         value="PDF"

                                        />}
                                        content={() => componentRef.current}
                                         />
                                          </div>
                                        <div hidden={true}>
                                             <CreatePdf ref={componentRef} data={data}
                                                rowNames={contentRowNames} searchData={selectedSearchValues} />

                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </Fragment >
    );
}



